import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { useAuth } from '../../auth';
import { getConnectorforInstace, getConnectorforInstacetenant, getConnectorforInstaceglobal, getConnectorforInstacetenantglobal } from './request/request';
import { Detail } from './components/Detail';
import { DetailCPR } from './components/DetailCPR';
import { DetailVPN } from './components/DetailVPN';

type connectors = {
  instance: any
  CPR: any
  VPN: any
  EDG: any
  ExtraEDG: {
    providerStatus: any
    equinixStatus: any
    errors: []
  }
  VPNList: [
    {
      status: any,
      connector: any,
      instance: any
    }
  ]
  CPRList: [
    {
      status: any,
      connector: any,
      instance: any
    }
  ]

  EDGList: [
    {
      status: any,
      connector: any,
      instance: any
    }
  ]
}

type ID = undefined | null | number

function StatusConectorEdg(props: any) {
  const [ID, setID] = useState<ID>(undefined)
  const [IDCPR, setIDCPR] = useState<ID>(undefined)
  const [IDVPN, setIDVPN] = useState<ID>(undefined)

  const { currentUser } = useAuth()
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type) || "CloudGlobal";

  /**********************Llamada a axios y parse de data**********************/

  const [data, setdata] = useState<connectors[]>([])
  const [detail, setdetail] = useState<any>()
  const [detaillistedg, setdetailistedg] = useState<any>()

  const [detailCPR, setdetailCPR] = useState<any>()
  const [detailVPN, setdetailVPN] = useState<any>()


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal') {
          if (tenant === 0) {
            const datos = await getConnectorforInstace(Id);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else {
            const available = await getConnectorforInstacetenant(Id, tenant);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }

      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, Type])


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Type === 'CloudGlobal') {
          if (tenant === 0) {
            const datos = await getConnectorforInstaceglobal(-1);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else {
            const available = await getConnectorforInstacetenantglobal(-1, tenant);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }

      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, Type])

  //////////////////////////////////////




  return (
    <>
      <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5 '>
          <h3 className='card-title align-items-start flex-column '>
            <span className=' f-titulo text-marino fs-md '>Connector Status</span>
          </h3>
          {/*Se agrega Boton para agregar usuarios*/}

        </div>

        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}
              <div className='table-responsive'>

                {/* begin::Table */}
                <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                  {/* begin::Table head */}
                  <thead>

                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>Instance</th>
                      <th className='table-cell'>Cloud </th>
                      <th className='table-cell'>VPN</th>
                      <th className='table-cell'>Edge</th>

                    </tr>
                  </thead>
                  {/* end::Table head */}

                  {/* begin::Table body */}
                  {Id !== 0 && Type !== 'CloudGlobal' && <tbody>
                    {data.map((d: any, i: any) => (
                      <tr key={i} className='table-row'>
                        {d.instance.includes(Type) && <td className='table-cell'>{d.instance}</td>}
                        {/******************************CPR****************************************** */}
                        {d.instance.includes(Type) && d.CPR === 'UP' ? <td className='table-cell'><i className="bi bi-check2-circle text-azul" style={{ fontSize: '24px' }} data-bs-toggle='tooltip'
                          title={d.CPR}  ></i>
                          <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDCPR(i), setdetailCPR(d.CPRList))} >
                            {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                            Detail
                            <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                          </button>
                        </td> :
                          d.instance.includes(Type) && d.CPR === 'DOWN' ?
                            <td className='table-cell'><i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                              data-bs-toggle='tooltip'
                              title={d.CPR}
                            ></i>
                              <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDCPR(i), setdetailCPR(d.CPRList))} >
                                {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                Detail
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                              </button>

                            </td> :
                            d.instance.includes(Type) && d.CPR === 'WARNING' ?
                              <td className='table-cell'><i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}
                                data-bs-toggle='tooltip'
                                title={d.CPR}
                              ></i>
                                <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDCPR(i), setdetailCPR(d.CPRList))} >
                                  {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                  Detail
                                  <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                                </button>

                              </td> :
                              d.instance.includes(Type) && d.CPR === null ?
                                <td className='table-cell'>
                                  <i className="fas bi bi-arrow-down-circle text-pink " style={{ fontSize: '24px' }}
                                    data-bs-toggle='tooltip'
                                    title={d.CPR === null ? 'DOWN' : d.CPR}
                                  ></i>
                                </td> :
                                d.instance.includes(Type) && <td className='table-cell'><i className="fas bi bi-arrow-down-circle text-pink " style={{ fontSize: '24px' }}></i></td>
                        }

                        {/******************************VPN****************************************** */}

                        {d.instance.includes(Type) && d.VPN === 'UP' ? <td className='table-cell'>
                          <i className="bi bi-check2-circle text-azul" style={{ fontSize: '24px' }}
                            data-bs-toggle='tooltip'
                            title={d.VPN}
                          ></i>
                          <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDVPN(i), setdetailVPN(d.VPNList))} >
                            {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                            Detail
                            <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                          </button>
                        </td> :
                          d.instance.includes(Type) && d.VPN === 'DOWN' ?
                            <td className='table-cell'>
                              <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                                data-bs-toggle='tooltip'
                                title={d.VPN}
                              ></i>
                              <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDVPN(i), setdetailVPN(d.VPNList))} >
                                {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                Detail
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                              </button>
                            </td> :
                            d.instance.includes(Type) && d.VPN === 'WARNING' ?
                              <td className='table-cell'><i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}
                                data-bs-toggle='tooltip'
                                title={d.VPN}
                              ></i>
                                <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDVPN(i), setdetailVPN(d.VPNList))} >
                                  {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                  Detail
                                  <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                                </button>

                              </td> :
                              d.instance.includes(Type) && d.VPN === null ? <td className='table-cell'>
                                <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                                  data-bs-toggle='tooltip'
                                  title={d.VPN === null ? 'DOWN' : d.VPN}
                                ></i>
                              </td> :
                                d.instance.includes(Type) && <td className='table-cell'>
                                  ----
                                </td>
                        }

                        {/******************************EDG****************************************** */}

                        {d.instance.includes(Type) && d.EDG === null ? <td className='table-cell'>
                          <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                            data-bs-toggle='tooltip'
                            title='DOWN'
                          ></i>
                        </td> :

                          d.instance.includes(Type) && d.EDG === 'WARNING' ? <td className='table-cell'>
                            <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}
                              data-bs-toggle='tooltip'
                              title='DOWN'
                            ></i>
                            <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setID(i), setdetail(d.ExtraEDG), setdetailistedg(d.EDGList))} >
                              {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                              Detail
                              <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                            </button>
                          </td> :

                            d.instance.includes(Type) && (d.EDG === 'AVAILABLE' || d.EDG === 'PROVISIONED' || d.EDG === 'PROVISIONING' || d.EDG === 'UP') ? <td className='table-cell'><i className="bi bi-check2-circle text-azul " style={{ fontSize: '24px' }} data-bs-toggle='tooltip'
                              title={d.EDG}></i>
                              <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setID(i), setdetail(d.ExtraEDG), setdetailistedg(d.EDGList))} >
                                {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                Detail
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                              </button>

                            </td> :

                              d.instance.includes(Type) && (d.EDG === 'DEPROVISIONED' || d.EDG === 'DEPROVISIONING' || d.EDG === 'NOT_AVAILABLE' || d.EDG === 'FAILED' || d.EDG === 'PENDING_APROVAL' || d.EDG === 'REJECTED'
                                || d.EDG === 'PENDING_BGP' || d.EDG === 'OUT_OF_BANDWITH' || d.EDG === 'DELETED' || d.EDG === 'ERROR' || d.EDG === 'ERRORED' || d.EDG === 'NOTPROVISIONED' || d.EDG === 'NOT_PROVISIONED'
                                || d.EDG === 'ORDERING' || d.EDG === 'DELETING' || d.EDG === 'PENDING_DELETE' || d.EDG === 'N/A' || d.EDG === 'DOWN') ?
                                <td className='table-cell'>
                                  <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                                    data-bs-toggle='tooltip'
                                    title={d.EDG}
                                  ></i>
                                  <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setID(i), setdetail(d.ExtraEDG), setdetailistedg(d.EDGList))} >
                                    {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                    Detail
                                    <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                                  </button>
                                </td> :
                                d.instance.includes(Type) && <td className='table-cell'><i className="fas bi bi-arrow-down-circle text-pink " style={{ fontSize: '24px' }}></i></td>

                        }



                      </tr>
                    ))
                    }
                  </tbody>}

                  {Type === 'CloudGlobal' && <tbody>
                    {data.map((d: any, i: any) => (
                      <tr key={i} className='table-row'>
                        <td className='table-cell'>{d.instance}</td>
                        {/******************************CPR****************************************** */}
                        {d.CPR === 'UP' ? <td className='table-cell'><i className="bi bi-check2-circle text-azul" style={{ fontSize: '24px' }} data-bs-toggle='tooltip'
                          title={d.CPR}  ></i>
                          <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDCPR(i), setdetailCPR(d.CPRList))} >
                            {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                            Detail
                            <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                          </button>
                        </td> :
                          d.CPR === 'DOWN' ?
                            <td className='table-cell'><i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                              data-bs-toggle='tooltip'
                              title={d.CPR}
                            ></i>
                              <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDCPR(i), setdetailCPR(d.CPRList))} >
                                {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                Detail
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                              </button>

                            </td> :
                            d.CPR === 'WARNING' ?
                              <td className='table-cell'><i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}
                                data-bs-toggle='tooltip'
                                title={d.CPR}
                              ></i>
                                <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDCPR(i), setdetailCPR(d.CPRList))} >
                                  {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                  Detail
                                  <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                                </button>

                              </td> :
                              d.CPR === null ?
                                <td className='table-cell'>
                                  <i className="fas bi bi-arrow-down-circle text-pink " style={{ fontSize: '24px' }}
                                    data-bs-toggle='tooltip'
                                    title={d.CPR === null ? 'DOWN' : d.CPR}
                                  ></i>
                                </td> :
                                <td className='table-cell'><i className="fas bi bi-arrow-down-circle text-pink " style={{ fontSize: '24px' }}></i></td>
                        }

                        {/******************************VPN****************************************** */}

                        {d.VPN === 'UP' ? <td className='table-cell'>
                          <i className="bi bi-check2-circle text-azul" style={{ fontSize: '24px' }}
                            data-bs-toggle='tooltip'
                            title={d.VPN}
                          ></i>
                          <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDVPN(i), setdetailVPN(d.VPNList))} >
                            {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                            Detail
                            <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                          </button>
                        </td> : d.VPN === 'DOWN' ?
                          <td className='table-cell'>
                            <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                              data-bs-toggle='tooltip'
                              title={d.VPN}
                            ></i>
                            <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDVPN(i), setdetailVPN(d.VPNList))} >
                              {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                              Detail
                              <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                            </button>
                          </td> :
                          d.VPN === 'WARNING' ?
                            <td className='table-cell'><i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}
                              data-bs-toggle='tooltip'
                              title={d.VPN}
                            ></i>
                              <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setIDVPN(i), setdetailVPN(d.VPNList))} >
                                {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                Detail
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                              </button>

                            </td> :
                            d.VPN === null ? <td className='table-cell'>
                              <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                                data-bs-toggle='tooltip'
                                title={d.VPN === null ? 'DOWN' : d.VPN}
                              ></i>
                            </td> :
                              <td className='table-cell'>
                                ----
                              </td>
                        }

                        {/******************************EDG****************************************** */}

                        {d.EDG === null ? <td className='table-cell'>
                          <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                            data-bs-toggle='tooltip'
                            title='DOWN'
                          ></i>
                        </td> :

                          d.EDG === 'WARNING' ? <td className='table-cell'>
                            <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}
                              data-bs-toggle='tooltip'
                              title='DOWN'
                            ></i>
                            <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setID(i), setdetail(d.ExtraEDG), setdetailistedg(d.EDGList))} >
                              {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                              Detail
                              <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                            </button>
                          </td> :

                            (d.EDG === 'AVAILABLE' || d.EDG === 'PROVISIONED' || d.EDG === 'PROVISIONING' || d.EDG === 'UP') ? <td className='table-cell'><i className="bi bi-check2-circle text-azul " style={{ fontSize: '24px' }} data-bs-toggle='tooltip'
                              title={d.EDG}></i>
                              <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setID(i), setdetail(d.ExtraEDG), setdetailistedg(d.EDGList))} >
                                {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                Detail
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                              </button>

                            </td> :

                              (d.EDG === 'DEPROVISIONED' || d.EDG === 'DEPROVISIONING' || d.EDG === 'NOT_AVAILABLE' || d.EDG === 'FAILED' || d.EDG === 'PENDING_APROVAL' || d.EDG === 'REJECTED'
                                || d.EDG === 'PENDING_BGP' || d.EDG === 'OUT_OF_BANDWITH' || d.EDG === 'DELETED' || d.EDG === 'ERROR' || d.EDG === 'ERRORED' || d.EDG === 'NOTPROVISIONED' || d.EDG === 'NOT_PROVISIONED'
                                || d.EDG === 'ORDERING' || d.EDG === 'DELETING' || d.EDG === 'PENDING_DELETE' || d.EDG === 'N/A' || d.EDG === 'DOWN') ?
                                <td className='table-cell'>
                                  <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}
                                    data-bs-toggle='tooltip'
                                    title={d.EDG}
                                  ></i>
                                  <button className="btn-relievech f-parrafo" style={{ marginLeft: '20px' }} onClick={() => (setID(i), setdetail(d.ExtraEDG), setdetailistedg(d.EDGList))} >
                                    {/*<i className="text-pink bi bi-arrow-up-right-square"></i>*/}
                                    Detail
                                    <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '15px' }} />
                                  </button>
                                </td> :
                                <td className='table-cell'><i className="fas bi bi-arrow-down-circle text-pink " style={{ fontSize: '24px' }}></i></td>

                        }



                      </tr>
                    ))
                    }
                  </tbody>}



                  {/* end::Table body */}

                </table>
                {/* end::Table */}

              </div>

              <br />
              <br />
              <div className='row'>
                <div className='col-auto'>
                  <i className="bi bi-check2-circle text-azul" style={{ fontSize: '24px' }}></i> <strong>UP</strong>
                </div>
                <div className='col-auto'>
                  <i className="fas bi bi-arrow-down-circle text-pink" style={{ fontSize: '24px' }}></i> <strong>DOWN</strong>
                </div>
                <div className='col-auto'>
                  <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '24px' }}></i> <strong>WARNING</strong>
                </div>
              </div>


            </div>
            {/* end::Tap pane */}
          </div>
        </div>
        <br />
        {/* end::Body */}
      </div>

      {ID !== undefined && <Detail setID={setID} id={ID} detail={detail} list={detaillistedg} />}
      {IDCPR !== undefined && <DetailCPR setID={setIDCPR} id={IDCPR} detail={detailCPR} />}
      {IDVPN !== undefined && <DetailVPN setID={setIDVPN} id={IDVPN} detail={detailVPN} />}

    </>

  );

}

export default StatusConectorEdg